export default function useConstants() {
  return Object.freeze({
    charts: {
      itemCountToShow: 10,
      chartAreaHeight: 300,
      barHeight: 24,
      footerChartHeight: 80,
      validDocumentsFooterChartHeight: 45,
    },
  });
}
